// Export CSV/PDF buttons row — mobile-first, MALAT-branded palette.
import { Download } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { downloadTransactionsCsv } from "@/lib/exportCsv";
import { downloadTransactionsPdf } from "@/lib/exportPdf";

export function ExportButtons({ filters }) {
  const { t, lang } = useI18n();
  const btn = "w-full px-3 py-3 rounded-2xl font-semibold text-sm flex items-center justify-center gap-1.5 active:scale-95";
  return (
    <div className="grid grid-cols-2 gap-2 w-full">
      <button data-testid="export-csv-btn" onClick={() => downloadTransactionsCsv(filters, t("csvReady"), t("error"))}
        className={`${btn} bg-primary text-primary-foreground`}>
        <Download className="w-4 h-4" /> CSV
      </button>
      <button data-testid="export-pdf-btn" onClick={() => downloadTransactionsPdf(filters, t("pdfReady"), t("error"), lang)}
        className={btn} style={{ background: "#f5b800", color: "#1e3a8a" }}>
        <Download className="w-4 h-4" /> PDF
      </button>
    </div>
  );
}
